module.exports = __webpack_public_path__ + "img/48_26.808e0a3f.png";